import theme from '@styles/theme';
export default {
  stickyLinks: {
    margin: ['10px 0 0 28px', '10px 0 0 28px', '10px auto 0 28px', '10px auto 0'],
    display: 'flex',
    width: 'auto',
    overflowX: 'hidden',
    '.swiper-slide': {
      fontFamily: `'${theme.fonts.uniform}'`,
      textTransform: 'uppercase',
      fontWeight: theme.fontWeights.medium,
      fontSize: `${theme.fontSizes.text}px`,
      width: 'auto',
      mr: '40px',
      whiteSpace: 'nowrap',
      button: {
        mr: 0
      },
      '&:last-of-type': {
        mr: 0
      }
    }
  }
};